/**
 * Feedback signals for a peck answer → `POST /pwa/api/feedback`.
 *
 * The backend copies phase/workload/provider/model from the referenced `usage`
 * row; the client sends only the call id and the signal. Nothing free-text.
 */
import { api } from './api';

export type Behavior = 'accepted' | 'kept' | 'copied' | 'edited' | 'regenerated' | 'discarded';

/** 👍 (`1`) / 👎 (`0`) on a two-point scale. */
export function sendRating(callId: string, score: 0 | 1): Promise<{ ok: boolean }> {
  return api.post<{ ok: boolean }>('/pwa/api/feedback', {
    call_id: callId,
    kind: 'rating',
    score,
    scale: 2,
  });
}

/** An implicit behaviour signal (copied, regenerated, discarded, …). */
export function sendBehavior(callId: string, behavior: Behavior): Promise<{ ok: boolean }> {
  return api.post<{ ok: boolean }>('/pwa/api/feedback', {
    call_id: callId,
    kind: 'behavior',
    behavior,
  });
}
